// Copyright (c) StrangeBee 2023

import { ExtractProps } from '@Molecules/Details/Details';
import { FormatDate } from '@Molecules/Format';
import React, { ReactElement } from 'react';
import { Space } from 'antd';
import { cutString } from '@Helpers/string';
import THTag from '@Atoms/THTag/THTag';
import { HTMLColors } from '@Constants/colors';
import { Link } from 'react-router-dom';

interface ExtractDataProps {
    locale: (...args: any[]) => any;
}

export const extractData = ({ locale }: ExtractDataProps): Record<string, ExtractProps> => ({
    '#computeTitle': {
        name: '',
        render: ({ title, icon, path }: { title: string; icon: ReactElement; path?: string }): ReactElement => (
            <div className="result-card__title">
                <Space>
                    {icon}
                    {path ? <Link to={path}>{title}</Link> : title}
                </Space>
            </div>
        ),
    },
    '#computeSource': {
        name: 'Sources',
        render: ({ title, icon, path }: { title: string; icon: ReactElement; path: string }): ReactElement => (
            <div className="result-card__title">
                <Space>
                    {icon}
                    <Link to={path}>{title}</Link>
                </Space>
            </div>
        ),
    },
    '#computeDate': {
        name: '',
        render: ({ dateStart, dateEnd }: { dateStart: number; dateEnd?: number }): ReactElement => (
            <div className="result-card__date">
                <FormatDate icon date={dateStart} />
                {dateEnd && <FormatDate label={locale('responder.list.ended-at') + ' '} date={dateEnd} />}
            </div>
        ),
    },
    status: {
        render: (status): ReactElement => (
            <THTag
                full
                value={status}
                color={
                    status === 'Success' ? HTMLColors.GREEN : status === 'Failure' ? HTMLColors.RED : HTMLColors.GRAY
                }
            />
        ),
    },
    '#computeDescription': {
        name: '',
        isForce: false,
        render: (description: string): ReactElement => (
            <div className="result-card__description">
                {description === 'N/A' ? locale('common.noDescription') : cutString(description, 140)}
            </div>
        ),
    },
});
